<template><section><h2>弧饼图</h2>
<p>弧饼图继承至饼图，使用了不同的图形进行渲染。</p>
<block-demo tip="" source="const data = [
  {
    type: &#39;污染源&#39;,
    count: 4454
  },

  {
    type: &#39;消防场所&#39;,
    count: 1239
  },

  {
    type: &#39;安全生产&#39;,
    count: 3758
  },

  {
    type: &#39;治安场所&#39;,
    count: 4300
  }
]

const { Chart, Pie, Legend } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;type&#39;,
  value: &#39;count&#39;
})

const pie = new Pie({
  radius: 0.6,
  innerRadius: 0.1,
  startAngle: 180,
  endAngle: 360
})

const legend = new Legend()

chart.append([pie, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'污染源'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">4454</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'消防场所'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">1239</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'安全生产'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">3758</span>
  },

  {
    <span class="hljs-attr">type</span>: <span class="hljs-string">'治安场所'</span>,
    <span class="hljs-attr">count</span>: <span class="hljs-number">4300</span>
  }
]

<span class="hljs-keyword">const</span> { Chart, Pie, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'type'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'count'</span>
})

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.6</span>,
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.1</span>,
  <span class="hljs-attr">startAngle</span>: <span class="hljs-number">180</span>,
  <span class="hljs-attr">endAngle</span>: <span class="hljs-number">360</span>
})

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()

chart.append([pie, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>